import Home from "../app/Home";

export default function Tab() {
  return <Home />;
}
